import DEFAULTS from './defaults'

const SYMBOLS = [...DEFAULTS]

export default SYMBOLS
